import store from '@/store'
// import {noticeAppUserAccountChanged} from './KdAppNative'

class KdH5Bridge {
  // 构造函数
  constructor (component) {
    this.component = component
    this.app = window.kdApp
  }

  // 获取当前桥的版本
  getBridgeVersion () {
    return '0.0.1'
  }

  // 客户端同步设备信息
  setDeviceData (data) {
    store.dispatch('device/setDeviceData', data)
  }

  // 客户端同步用户信息
  setUserData (data) {
    store.dispatch('user/setUserData', data)
  }

  // 设置当前选中的企业ID
  setSelectOrgId (data) {
    store.dispatch('user/selectOrgId', data)
  }
}

export default KdH5Bridge



// WEBPACK FOOTER //
// ./src/api/KdH5Bridge.js